import React, { useState, useEffect } from 'react';
import { Modal, Button, Drawer } from 'antd';
// import { Temp_State } from '../../../Assets/data/stateList.json';
import logo from '../../../Assets/images/logo.svg';
import nav from '../../../Assets/images/nav.svg';
import closenav from '../../../Assets/images/closenav.svg';
import search from '../../../Assets/images/search.svg';
import searchclose from '../../../Assets/images/searchclose.svg';
import mobile_nav_bottom_dog from '../../../Assets/images/mobile_nav_bottom_dog.svg';


function Header(props) {
  const [isNavOpen, toggleNav] = useState(false);
  const [zipCode, setZipcode] = useState();
  const [isVisible, toggleModalVisibility] = useState(false);
  const [navPath, setNavPath] = useState();
  const [is_search, setMounted] = useState();
  const [signoutTime] = useState(900000);
  // const [signoutTime, setSignoutTime] = useState(10000);
  let logoutTimeout;
  
  const logout = () => {
    console.log('You have been loged out');
    localStorage.clear(); 
    sessionStorage.clear(); 
    localStorage.removeItem('is_edit'); 
    window.location.assign('/login')
  }

  const setTimeouts = () => {
    logoutTimeout = setTimeout(logout, signoutTime);
  };

  const clearTimeouts = () => {
    if (logoutTimeout) clearTimeout(logoutTimeout);
  };

  const confirmNavigateAway = (e, path) => {
    e.preventDefault();
    if (props.inProgress) {
      toggleModalVisibility(true);
      setNavPath(path);
    } else {
      window.location.assign(path)
    }
  }

  useEffect(() => {
    const zipcode = JSON.parse(sessionStorage.getItem('area'));
    setZipcode(zipcode)

    let user = JSON.parse(localStorage.getItem('userKey'));
    if (user) {
      const events = [
        'load',
        'mousemove',
        'mousedown',
        'click',
        'scroll',
        'keypress'
      ];

      const resetTimeout = () => {
        clearTimeouts();
        setTimeouts();
      };

      for (let i in events) {
        window.addEventListener(events[i], resetTimeout);
      }

      setTimeouts();
      return () => {
        for(let i in events){
          window.removeEventListener(events[i], resetTimeout);
          clearTimeouts();
        }
      }
    }
  }, []);
  // Toggle search bar
  const toggleSearch = () => setMounted(!is_search, toggleNav());
  // Toggle Navbar
  const navhide = () => toggleNav(!isNavOpen, setMounted());
  let UserDetails = JSON.parse(localStorage.getItem('userKey')) || null
  return (
    <React.Fragment>
      {/* Web nav */}
      <nav className='navbar navbar-expand-md navbar-light bg-light custom_nav'>
        <div className='container d-block'>
          <div className="d-flex justify-content-between align-items-center">
            <a
              className='navbar-brand'
              href='https://www.doodycalls.com/'
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={logo} alt="" />
            </a>
            <button
              className='navbar-toggler'
              onClick={() => toggleNav(!isNavOpen)}
              type='button'
              data-toggle='collapse'
              data-target='#navbarTogglerDemo02'
              aria-controls='navbarTogglerDemo02'
              aria-expanded='false'
              aria-label='Toggle navigation'
            >
              <span className='navbar-toggler-icon'></span>
            </button>

            {
              !props.hideLinks &&
              <div
                className={
                  isNavOpen
                    ? ' d-block collapse navbar-collapse'
                    : 'collapse navbar-collapse'
                }
              >
                <ul className='navbar-nav mr-auto'>
                  <li className='nav-item'>
                    <a
                      className='nav-link '
                      href='https://www.doodycalls.com/about-us/'
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                    About Us
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href='https://www.doodycalls.com/residential-services/'
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                    Residential Services
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href='https://www.doodycalls.com/commercial-services/'
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                    Commercial Services
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href='https://www.doodycalls.com/products/'
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                    Products
                    </a>
                  </li>
                
                </ul>
                <div className='ml-auto right_nav'>
                  {/* <div className='search_box_wrapper'>
                  <input
                    className='form-control header_search_box'
                    type='search'
                    name="search"
                    placeholder='Search'
                  />
                  <i className='las la-search'></i>
                </div> */
                    <a
                      target="_blank"
                      href='https://www.doodycalls.com/site-search/'
                      className='signin_link' rel="noreferrer"
                    >
                    Search
                    </a>
                  }

                  {!UserDetails ?
                    <a
                      href='/login'
                      onClick={(e) => confirmNavigateAway(e, '/login')}
                      className='signin_link'
                    >
                    Sign In
                    </a> : ''}
                  {/* <button
                  className='btn free_quote'
                  type='button'
                  onClick={(e) => {
                    confirmNavigateAway(e, '/');
                    if (UserDetails && UserDetails?.user) {
                      localStorage.setItem('is_edit', JSON.stringify({ 'is_edit': true }));
                      if (UserDetails?.user?.role.includes('commercial_customer')) {
                        localStorage.setItem('is_property_type', JSON.stringify({ property_type: 'community' }));
                      }
                      else {
                        localStorage.setItem('is_property_type', JSON.stringify({ property_type: 'residential' }));
                      }
                    }
                  }
                  }
                >
                  Free Quote

                </button> */}
                  {UserDetails ?
                    <div className="after_login">
                      <label className="username">Welcome, {UserDetails && UserDetails.user && UserDetails.user.first_name ? UserDetails.user.first_name : 'Tom'}</label>
                      <div className="action_nav">
                        <a href="/#" onClick={(e) => { e.preventDefault(); localStorage.removeItem('is_edit'); window.location.assign('/account') }}>My Account</a>
                        <a href="/#" onClick={(e) => { e.preventDefault(); localStorage.clear(); sessionStorage.clear(); localStorage.removeItem('is_edit'); window.location.assign('/login') }}>Sign Out</a>
                      </div>
                    </div> : ''}
                </div>
              </div>
            }
            </div>
          </div>
        </nav>

        {/* Mobile nav */}
        <div className="mobile_nav">
          <nav>
            <a
              className='navbar-brand'
              href='/'
              onClick={(e) => confirmNavigateAway(e, '/')}
            >
              <img src={logo} alt="" />
            </a>
            <div className="search_nav_btn">
              <div className="search_icon_wrapper"><img src={is_search ? searchclose : search} alt="" onClick={toggleSearch} className="search_btn" /></div>
              <div className="nav_icon_wrapper"><img src={isNavOpen ? closenav : nav} alt="" onClick={navhide} /></div>
            </div>
          </nav>
          <div className={is_search ? 'mob_search_box_wrapper' : 'hide_search_box'}>
            <input type="text" className="form--control" name="" placeholder="Search" />
          </div>

          <Drawer
            title="Basic Drawer"
            placement="right"
            closable
            onClose={() => toggleNav(!isNavOpen)}
            visible={isNavOpen}
            getContainer={false}

          >
            <ul className="mobile_nav_list">
              <li><a href='/#' onClick={(e) => { e.preventDefault(); }}>About Us</a></li>
              <li> <a href="/#" onClick={(e) => { e.preventDefault(); localStorage.removeItem('is_edit'); window.location.assign('/account') }}>My Account</a></li>
              <li><a href='/#' onClick={(e) => { e.preventDefault(); }}>Services</a></li>
              <li><a href='/#' onClick={(e) => { e.preventDefault(); }}>Pet Waste Stations & Bags</a></li>
              
              <li><a href="https://www.doodycalls.com/contact-us/" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
            </ul>

            <ul className="mobile_bottom_nav">
              {UserDetails ? <li><a href="/#" className="signin_link" onClick={(e) => { e.preventDefault(); localStorage.clear(); sessionStorage.clear(); localStorage.removeItem('is_edit'); window.location.assign('/login') }}>Sign Out</a></li> : <li><a href="/#" className="signin_link" onClick={(e) => confirmNavigateAway(e, '/login')}>Sign In</a></li>}

              {/* <li><a href="/#" className="free_quote" onClick={(e) => confirmNavigateAway(e, '/')}>Free Quote</a></li> */}
              <li><img src={mobile_nav_bottom_dog} alt="" /></li>
            </ul>

          </Drawer>
        </div>

        <div className='doody_bar'>
          <div className='container'>
            <div className='doody_bar_wrapper'>
              {/* {console.log(zipCode)} */}
              {/* <div className='zipcode_enter'>
                {!UserDetails ?
                  <React.Fragment>
                    {zipCode ? (
                      <label className="address_label">
                        {`${zipCode.city},${zipCode.state} ${zipCode.zipcode}`}
                      </label>
                    ) : (
                      <label className="text_label">Find a DoodyCalls near you</label>
                    )}
                    {zipCode ? (
                      <a href='/' onClick={(e) => confirmNavigateAway(e, '/')}>
                        New ZIP
                      </a>
                    ) : (
                      <a
                        href='/#'
                        onClick={(e) => {
                          e.preventDefault();
                          window.location.assign('/');
                        }}
                      >
                          Enter ZIP
                      </a>
                    )}
                  </React.Fragment>
                  : ''}
              </div> */}
              <div className='contact_bar ml-auto'>
                <label>
                  Questions?{' '}
                  <a
                    href="https://www.doodycalls.com/contact-us/" target="_blank" rel="noopener noreferrer"                >
                    Contact Us
                  </a>
                </label>
                <a
                  href='/#'
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <i className='las la-phone'></i>
                    1-(888) 659-6558
                </a>
              </div>
            </div>
          </div>
        </div>
      <Modal
        className="detached_modal"
        visible={isVisible}
        onCancel={() => toggleModalVisibility(false)}
        footer={[
          <Button key="exist" className="btn-outline--primary" type="primary" onClick={() => {
            toggleModalVisibility(false);
            window.location.assign(navPath)
          }}>
            Exit
          </Button>,
          <Button key="submit" type="primary" onClick={() => toggleModalVisibility(false)}>
            Continue my quote
          </Button>,
        ]}
      >
        <h4 className="modal_title">Are you sure?</h4>
        <p className="desc">You are about to exit without finalising your quote!
          If you choose to exit, your progress will be lost and you will have to start your quote again.</p>
      </Modal>
      <div className={is_search ? "overlay_mask" : ""}></div>

    </React.Fragment >
  );
}

export default Header;